import angular from 'angular';
import CallFramesController from './call-frames.controller';
import template from './call-frames.html';
import './call-frames.styles/_import.scss';
import selfVideoFrame from './self-video-frame/self-video-frame';
import selfScreenFrame from './self-screen-frame/self-screen-frame';
import participantVideoFrame from './participant-video-frame/participant-video-frame';
import callFramesMic from './elements/call-frames-mic/call-frames-mic';
import callFramesConnection from './elements/call-frames-connection/call-frames-connection';
import callFramesStats from './elements/call-frames-stats/call-frames-stats';
import callFramesMediaActions from './elements/call-frames-media-actions/call-frames-media-actions';
import toggleSidebarBtn from './elements/toggle-sidebar-btn/toggle-sidebar-btn';
import selfVideoExpandBtn from './self-video-expand-btn/self-video-expand-btn';
import downgradeToAudioOnlyFrame from './elements/downgrade-to-audio-only-frame/downgrade-to-audio-only-frame';
const callFramesComponent = {
    template,
    bindings: {
        isPatient: '<',
        isGalleryView: '<',
        cameraOff: '<',
        patientModalOpen: '<',
        shouldShowPublisher: '<',
        isCheckInPhotoCaptureEnabled: '<',
    },
    controller: CallFramesController,
};
export default angular
    .module('doxy.videoChat.callFrames', [
    selfVideoFrame,
    selfScreenFrame,
    participantVideoFrame,
    callFramesMic,
    toggleSidebarBtn,
    downgradeToAudioOnlyFrame,
    selfVideoExpandBtn,
    callFramesConnection,
    callFramesStats,
    callFramesMediaActions,
])
    .component('callFrames', callFramesComponent).name;
